import { useState } from "react";
import { Flex, Text, IconButton, Tooltip } from "@radix-ui/themes";
import { RefreshCw } from "lucide-react";

const version = __APP_VERSION__;
const buildNumber = __BUILD_NUMBER__;
const buildDate = new Date(__BUILD_TIME__);
const buildLabel = buildDate.toISOString().substring(0, 10);

async function hardRefresh() {
  // 1. Désabonner tous les service workers
  if ("serviceWorker" in navigator) {
    const registrations = await navigator.serviceWorker.getRegistrations();
    await Promise.all(registrations.map((r) => r.unregister()));
  }

  // 2. Vider tous les caches
  if ("caches" in window) {
    const keys = await caches.keys();
    await Promise.all(keys.map((k) => caches.delete(k)));
  }

  // 3. Recharger sans cache
  window.location.reload();
}

interface AppVersionProps {
  compact?: boolean;
}

export function AppVersion({ compact = false }: AppVersionProps) {
  const [loading, setLoading] = useState(false);

  const handleRefresh = async () => {
    setLoading(true);
    await hardRefresh();
  };

  const fullLabel = `v${version} · build ${buildNumber} · ${buildLabel}`;
  const compactLabel = `v${version} · b${buildNumber}`;

  return (
    <Flex align="center" gap="1">
      <Tooltip content={fullLabel}>
        <Text size="1" color="gray" style={{ fontVariantNumeric: "tabular-nums", opacity: 0.7, whiteSpace: "nowrap" }}>
          {compact ? compactLabel : fullLabel}
        </Text>
      </Tooltip>
      <Tooltip content="Vider le cache et rafraîchir">
        <IconButton
          size="1"
          variant="ghost"
          color="gray"
          onClick={handleRefresh}
          disabled={loading}
          aria-label="Vider le cache et rafraîchir"
        >
          <RefreshCw size={11} style={loading ? { animation: "spin 1s linear infinite" } : {}} />
        </IconButton>
      </Tooltip>
    </Flex>
  );
}
